import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FeatureFlagInterceptor } from '@app/interceptors/featureFlag-interceptor.class';

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: FeatureFlagInterceptor,
            multi: true,
        },
    ],
})
export class FeatureFlagInterceptorModule {}
